import Ajax from '@/api/ajax'
import Request from '@/api/request'
import store from '@/store'

const api = (url, timeout) => {
  return (params) => {
    const ajax = new Ajax(url, timeout)

    params.language = store.state.apps.language
    const req = new Request(params)

    return ajax.send(req)
  }
}

/**
 * API
 */
export default {
  areaList: api('/api/AreaList'),
  certify: api('/api/Certify'),
  checkIn: api('/api/Checkin'),
  checkOut: api('/api/Checkout'),
  contactRegist: api('/api/ContactRegist'),
  loginInfo: api('/api/LoginInfo'),
  logout: api('/api/Logout'),
  master: api('/api/Master'),
  passForget: api('/api/PassForget'),
  passRegist: api('/api/PassRegist'),
  reserve: api('/api/Reserve'),
  reserveList: api('/api/ReserveList'),
  reserveRegist: api('/api/ReserveRegist'),
  reserveCancel: api('/api/ReserveCancel'),
  shop: api('/api/Shop'),
  shopImage: api('/api/ShopImage'),
  shopImageRegist: api('/api/ShopImageRegist', true),
  shopList: api('/api/ShopList'),
  shopRecipe: api('/api/ShopRecipe'),
  shopRecipeList: api('/api/ShopRecipeList', true),
  shopRecipeRegist: api('/api/ShopRecipeRegist', true),
  shopUser: api('/api/ShopUser'),
  shopUserRegist: api('/api/ShopUserRegist'),
  stationList: api('/api/StationList'),
  usageFeeCalc: api('/api/UsageFeeCalc'),
  user: api('/api/User'),
  userEntry: api('/api/UserEntry'),
  userHashConfirm: api('/api/UserHashConfirm'),
  userRegist: api('/api/UserRegist')
}
